Vue.component('ack-shop', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-shop',
	mixins: [languageMixins],
	created() {
		if (!this.storeAvailable || this.isUS_CA || this.isIreland) {
			window.location = '/';
		}

		this.initPageView();

		this.productSortSelect = this.sortCriteria;

		EventBus.$on('reset-accordionsAll', () => {
			this.toBeActiveAccordionList.forEach((openedAccordion) => {
				let collapseToBeCloseEle = document.querySelector(
					`#${openedAccordion.replace('heading', 'collapse')}`,
				);
				const collapseToBeClose = bootstrap.Collapse.getOrCreateInstance(collapseToBeCloseEle);
				collapseToBeClose.hide();
				collapseToBeClose.dispose();
			});
		});
	},
	props: {
		article: {
			type: Object,
		},
	},
	computed: {
		...Vuex.mapGetters('shop', [
			'numberOfSelectedProducts',
			'numberOfCartProducts',
			'selectedProductList',
			'numberOfProducts',
			'PRODUCT_SORT_CRITERIA',
			'sortCriteria',
			'currentPage',
			'totalPages',
			'totalResults',
			'resultsPerPage',
			'numberOfCheckedFilters',
			'isBundleView',
			'totalSelectedPrice',
			'currentCurrency',
			'collectionProductList',
			'toBeActiveAccordionList',
		]),
		...Vuex.mapGetters('localization', ['countryCode', 'isAU_NZ', 'isUS_CA', 'isIreland']),
		isMobile() {
			return this.$parent.isMobile;
		},

		prevDisabled() {
			return this.currentPage === 1;
		},
		nextDisabled() {
			return this.currentPage === this.totalPages;
		},
		numberOfSelectableProducts() {
			let num = 0;

			if (this.totalResults < this.resultsPerPage) {
				num = this.totalResults;
			} else {
				num = this.resultsPerPage;
			}

			return num;
		},

		showSelectAllProducts() {
			let show = false;
			if (this.totalResults > this.numberOfSelectedProducts) {
				show = true;
			}
			return show;
		},

		storeAvailable() {
			let avl = true;
			if (this.countryCode.toUpperCase() == 'US' || this.countryCode.toUpperCase() == 'CA') {
				avl = true;
			}
			return avl;
		},

		isUSorCA() {
			return this.countryCode.toUpperCase() === 'US' || this.countryCode.toUpperCase() === 'CA';
		},
	},
	data() {
		return {
			pageId: 'shop-page',
			mobileMenuOpened: false,
			productSortSelect: null,
			numeralFormatter: numeral,
			selectedBundle: null,
			bundleTitle: '',
			bundleDescription: '',
			filters: {
				cleaniDualTanksProduct: {
					cleani_dual_tank: {
						label:
							'shop.category_filters.categories.post_processing.cleani_dual_tank.cleani_dual_tank',
						id: 'cleani_dual_tank',
						shopifyId: 'gid://shopify/Product/6555508703335',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					accessories: {
						label: 'shop.category_filters.categories.post_processing.cleani_dual_tank.accessories',
					},
					cleani_dual_tank_kit: {
						label:
							'shop.category_filters.categories.post_processing.cleani_dual_tank.cleani_dual_tank_kit',
						shopifyId: 'gid://shopify/Product/6897863721063',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					hydrometer: {
						label: 'shop.category_filters.categories.post_processing.cleani_dual_tank.hydrometer',
						shopifyId: 'gid://shopify/Product/6915766321255',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					power_cable_ac_adapter: {
						label:
							'shop.category_filters.categories.post_processing.cleani_dual_tank.power_cable_ac_adapter',
						shopifyId: 'gid://shopify/Product/6643132235879',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				cleaniDualTanksProductUsCa: {
					cleani_dual_tank: {
						label:
							'shop.category_filters.categories.post_processing.cleani_dual_tank.cleani_dual_tank',
						id: 'cleani_dual_tank',
						shopifyId: 'gid://shopify/Product/6555508703335',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					accessories: {
						label: 'shop.category_filters.categories.post_processing.cleani_dual_tank.accessories',
					},
					cleani_plus_tank_kit: {
						label:
							'shop.category_filters.categories.post_processing.cleani_dual_tank.cleani_plus_tank_kit',
						shopifyId: 'gid://shopify/Product/6897863852135',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					cleani_dual_tank_kit: {
						label:
							'shop.category_filters.categories.post_processing.cleani_dual_tank.cleani_dual_tank_kit',
						shopifyId: 'gid://shopify/Product/6897863721063',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					hydrometer: {
						label: 'shop.category_filters.categories.post_processing.cleani_dual_tank.hydrometer',
						shopifyId: 'gid://shopify/Product/6915766321255',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					power_cable_ac_adapter: {
						label:
							'shop.category_filters.categories.post_processing.cleani_dual_tank.power_cable_ac_adapter',
						shopifyId: 'gid://shopify/Product/6643132235879',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				cleaniTankPlusProduct: {
					cleani_tank_plus: {
						label:
							'shop.category_filters.categories.post_processing.cleani_tank_plus.cleani_tank_plus',
						id: 'cleani_tank_plus',
						shopifyId: 'gid://shopify/Product/6857633071207',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					accessories: {
						label: 'shop.category_filters.categories.post_processing.cleani_tank_plus.accessories',
					},
					cleani_tank_plus_kit: {
						label:
							'shop.category_filters.categories.post_processing.cleani_tank_plus.cleani_tank_plus_kit',
						shopifyId: 'gid://shopify/Product/6897863852135',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					hydrometer: {
						label: 'shop.category_filters.categories.post_processing.cleani_tank_plus.hydrometer',
						shopifyId: 'gid://shopify/Product/6915766321255',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					power_cable_ac_adapter: {
						label:
							'shop.category_filters.categories.post_processing.cleani_tank_plus.power_cable_ac_adapter',
						shopifyId: 'gid://shopify/Product/6643132235879',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				solProduct: {
					sol: {
						label: 'shop.category_filters.categories.3d_printers.sol.sol',
						id: 'sol',
						shopifyId: 'gid://shopify/Product/6549949284455',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					accessories: { label: 'shop.category_filters.categories.3d_printers.sol.accessories' },
					sol_large_bp: {
						label: 'shop.category_filters.categories.3d_printers.sol.large_bp',
						id: 'sol_large_bp',
						shopifyId: 'gid://shopify/Product/6590433951847',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					sol_medium_bp: {
						label: 'shop.category_filters.categories.3d_printers.sol.medium_bp',
						id: 'sol_medium_bp',
						shopifyId: 'gid://shopify/Product/6630922485863',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					sol_small_bp: {
						label: 'shop.category_filters.categories.3d_printers.sol.small_bp',
						id: 'sol_small_bp',
						shopifyId: 'gid://shopify/Product/6630921502823',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					sol_vat_assembly_with_vat_box: {
						label: 'shop.category_filters.categories.3d_printers.sol.sol_vat_assembly',
						id: 'sol_vat_assembly',
						shopifyId: 'gid://shopify/Product/6590433722471',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					sol_vat_box: {
						label: 'shop.category_filters.categories.3d_printers.sol.sol_vat_box',
						id: 'sol_vat_box',
						shopifyId: 'gid://shopify/Product/6776822038631',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					starter_tool_kit: {
						label: 'shop.category_filters.categories.3d_printers.sol.starter_tool_kit',
						id: 'starter_tool_kit',
						shopifyId: 'gid://shopify/Product/6841026019431',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					power_cable: {
						label: 'shop.category_filters.categories.3d_printers.sol.power_cable',
						id: 'power_cable',
						shopifyId: 'gid://shopify/Product/6606441087079',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					wifi_dongle: {
						label: 'shop.category_filters.categories.3d_printers.sol.wifi_dongle',
						id: 'wifi_dongle',
						shopifyId: 'gid://shopify/Product/6606440988775',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					print_screen: {
						label: 'shop.category_filters.categories.3d_printers.sol.print_screen',
						id: 'print_screen',
						shopifyId: 'gid://shopify/Product/6590434672743',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				solUsCaProduct: {
					sol: {
						label: 'shop.category_filters.categories.3d_printers.sol.sol',
						id: 'sol',
						shopifyId: 'gid://shopify/Product/7096825839719', //SOL with Concierge Service
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					accessories: { label: 'shop.category_filters.categories.3d_printers.sol.accessories' },
					sol_large_bp: {
						label: 'shop.category_filters.categories.3d_printers.sol.large_bp',
						id: 'sol_large_bp',
						shopifyId: 'gid://shopify/Product/6590433951847',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					sol_medium_bp: {
						label: 'shop.category_filters.categories.3d_printers.sol.medium_bp',
						id: 'sol_medium_bp',
						shopifyId: 'gid://shopify/Product/6630922485863',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					sol_small_bp: {
						label: 'shop.category_filters.categories.3d_printers.sol.small_bp',
						id: 'sol_small_bp',
						shopifyId: 'gid://shopify/Product/6630921502823',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					sol_vat_assembly_with_vat_box: {
						label: 'shop.category_filters.categories.3d_printers.sol.sol_vat_assembly',
						id: 'sol_vat_assembly',
						shopifyId: 'gid://shopify/Product/6590433722471',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					sol_vat_box: {
						label: 'shop.category_filters.categories.3d_printers.sol.sol_vat_box',
						id: 'sol_vat_box',
						shopifyId: 'gid://shopify/Product/6776822038631',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					// starter_tool_kit: {label:'shop.category_filters.categories.3d_printers.sol.starter_tool_kit', id: 'starter_tool_kit', shopifyId: 'gid://shopify/Product/6841026019431', variantId: '', checked: false , sellingPlanId: ''},
					power_cable: {
						label: 'shop.category_filters.categories.3d_printers.sol.power_cable',
						id: 'power_cable',
						shopifyId: 'gid://shopify/Product/6606441087079',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					wifi_dongle: {
						label: 'shop.category_filters.categories.3d_printers.sol.wifi_dongle',
						id: 'wifi_dongle',
						shopifyId: 'gid://shopify/Product/6606440988775',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				dentiqProduct: {
					dentiq: {
						label: 'shop.category_filters.categories.3d_printers.dentiq.dentiq',
						id: 'dentiq',
						shopifyId: 'gid://shopify/Product/6548762591335',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					accessories: { label: 'shop.category_filters.categories.3d_printers.dentiq.accessories' },
					dentiq_build_platform: {
						label: 'shop.category_filters.categories.3d_printers.dentiq.dentiq_build_platform',
						id: 'dentiq_build_platform',
						shopifyId: 'gid://shopify/Product/6590433132647',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					dentiq_vat: {
						label: 'shop.category_filters.categories.3d_printers.dentiq.dentiq_vat',
						id: 'dentiq_vat',
						shopifyId: 'gid://shopify/Product/6590432247911',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					print_screen: {
						label: 'shop.category_filters.categories.3d_printers.dentiq.print_screen',
						id: 'print_screen',
						shopifyId: 'gid://shopify/Product/6569639837799',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				solplusProduct: {
					sol_plus: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.sol_plus',
						id: 'sol_plus',
						shopifyId: 'gid://shopify/Product/6857640837223',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					accessories: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.accessories',
					},
					sol_plus_xl_bp: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.xl_bp',
						id: 'xl_bp',
						shopifyId: 'gid://shopify/Product/6888831844455',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					sol_plus_vat_assembly: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.sol_plus_vat_assembly',
						id: 'sol_plus_vat_assembly',
						shopifyId: 'gid://shopify/Product/6888878833767',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					vat_boxes: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.vat_boxes',
						id: 'vat_boxes',
						shopifyId: 'gid://shopify/Product/6888888729703',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					print_screen: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.print_screen',
						id: 'print_screen',
						shopifyId: 'gid://shopify/Product/6888890630247',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					heating_rod: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.heating_rod',
						id: 'heating_rod',
						shopifyId: 'gid://shopify/Product/6888892006503',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					// starter_tool_kit: {label:'shop.category_filters.categories.3d_printers.sol_plus.starter_tool_kit', id: 'starter_tool_kit', shopifyId: 'gid://shopify/Product/7096899862631', variantId: '', checked: false , sellingPlanId: ''},
					power_cable: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.power_cable',
						id: 'power_cable',
						shopifyId: 'gid://shopify/Product/6606441087079',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					wifi_dongle: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.wifi_dongle',
						id: 'wifi_dongle',
						shopifyId: 'gid://shopify/Product/6606440988775',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				solplusUsCaProduct: {
					sol_plus: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.sol_plus',
						id: 'sol_plus',
						shopifyId: 'gid://shopify/Product/7096869191783', //SOL Plus with Concierge Service
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					accessories: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.accessories',
					},
					sol_plus_xl_bp: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.xl_bp',
						id: 'xl_bp',
						shopifyId: 'gid://shopify/Product/6888831844455',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					sol_plus_vat_assembly: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.sol_plus_vat_assembly',
						id: 'sol_plus_vat_assembly',
						shopifyId: 'gid://shopify/Product/6888878833767',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					vat_boxes: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.vat_boxes',
						id: 'vat_boxes',
						shopifyId: 'gid://shopify/Product/6888888729703',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					heating_rod: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.heating_rod',
						id: 'heating_rod',
						shopifyId: 'gid://shopify/Product/6888892006503',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					// starter_tool_kit: {label:'shop.category_filters.categories.3d_printers.sol_plus.starter_tool_kit', id: 'starter_tool_kit', shopifyId: 'gid://shopify/Product/7096899862631', variantId: '', checked: false , sellingPlanId: ''},
					power_cable: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.power_cable',
						id: 'power_cable',
						shopifyId: 'gid://shopify/Product/6606441087079',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					wifi_dongle: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.wifi_dongle',
						id: 'wifi_dongle',
						shopifyId: 'gid://shopify/Product/6606440988775',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				// freeshapeProduct: {
				// 	freeshape: {
				// 		label: 'shop.category_filters.categories.3d_printers.freeshape.freeshape',
				// 		id: 'freeshape',
				// 		shopifyId: 'gid://shopify/Product/4396535382119',
				// 		variantId: '',
				// 		checked: false,
				// 		sellingPlanId: '',
				// 	},
				// 	accessories: {
				// 		label: 'shop.category_filters.categories.3d_printers.freeshape.accessories',
				// 	},
				// 	freeshape_vat: {
				// 		label: 'shop.category_filters.categories.3d_printers.freeshape.freeshape_vat',
				// 		id: 'freeshape_vat',
				// 		shopifyId: 'gid://shopify/Product/6569637773415',
				// 		variantId: '',
				// 		checked: false,
				// 		sellingPlanId: '',
				// 	},
				// 	freeshape_build_platform: {
				// 		label:
				// 			'shop.category_filters.categories.3d_printers.freeshape.freeshape_build_platform',
				// 		id: 'freeshape_build_platform',
				// 		shopifyId: 'gid://shopify/Product/4426777428071',
				// 		variantId: '',
				// 		checked: false,
				// 		sellingPlanId: '',
				// 	},
				// },
				curiePlusProduct: {
					curie_plus: {
						label: 'shop.category_filters.categories.post_processing.curie_plus.curie_plus',
						id: 'curie_plus',
						shopifyId: 'gid://shopify/Product/6770993332327',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					accessories: {
						label: 'shop.category_filters.categories.post_processing.curie_plus.accessories',
					},
					n2_cover: {
						label: 'shop.category_filters.categories.post_processing.curie_plus.n2_cover_kit',
						id: 'n2_cover_kit',
						shopifyId: 'gid://shopify/Product/6841034113127',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					glass: {
						label: 'shop.category_filters.categories.post_processing.curie_plus.glass',
						id: 'glass',
						shopifyId: 'gid://shopify/Product/7112867905639',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					power_cable: {
						label: 'shop.category_filters.categories.post_processing.curie_plus.power_cable',
						id: 'power_cable',
						shopifyId: 'gid://shopify/Product/6606441087079',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					wifi_dongle: {
						label: 'shop.category_filters.categories.post_processing.curie_plus.wifi_dongle',
						id: 'wifi_dongle',
						shopifyId: 'gid://shopify/Product/6606440988775',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				nfinityProduct: {
					nfinity: {
						label: 'shop.category_filters.categories.post_processing.curie_plus.nfinity',
						id: 'nfinity',
						shopifyId: 'gid://shopify/Product/6997757198439',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				curieProduct: {
					curie: {
						label: 'shop.category_filters.categories.post_processing.curie.curie',
						id: 'curie',
						shopifyId: 'gid://shopify/Product/6555508670567',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					accessories: {
						label: 'shop.category_filters.categories.post_processing.curie.accessories',
					},
					glass: {
						label: 'shop.category_filters.categories.post_processing.curie.glass',
						id: 'glass',
						shopifyId: 'gid://shopify/Product/6643132399719',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					power_cable: {
						label: 'shop.category_filters.categories.post_processing.curie.power_cable',
						id: 'power_cable',
						shopifyId: 'gid://shopify/Product/6606441087079',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				uvBoxProduct: {
					uv_box: {
						label: 'shop.category_filters.categories.post_processing.uv_box.uv_box',
						id: 'uv_box',
						shopifyId: 'gid://shopify/Product/6571819466855',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				softwareProduct: {
					// alpha_ai:{label: 'shop.category_filters.categories.software.alpha_ai.alpha_ai', id: 'alpha_ai', shopifyId: 'gid://shopify/Product/', variantId: '', checked: false , sellingPlanId: ''},
					accessories: { label: 'shop.category_filters.categories.software.alpha_ai.alpha_ai' },
					alpha_ai_premium_monthly: {
						label: 'shop.category_filters.categories.software.alpha_ai.alpha_ai_premium_monthly',
						id: 'alpha_ai_premium_monthly',
						shopifyId: 'gid://shopify/Product/6777579962471',
						variantId: 'gid://shopify/ProductVariant/40179161137255',
						checked: false,
						sellingPlanId: 'gid://shopify/SellingPlan/7707689063',
					},
					alpha_ai_premium_1year: {
						label: 'shop.category_filters.categories.software.alpha_ai.alpha_ai_premium_1year',
						id: 'alpha_ai_premium_1year',
						shopifyId: 'gid://shopify/Product/6777577046119',
						variantId: 'gid://shopify/ProductVariant/41256766079079',
						checked: false,
						sellingPlanId: 'gid://shopify/SellingPlan/7588380775',
					},
					alpha_ai_premium_2year: {
						label: 'shop.category_filters.categories.software.alpha_ai.alpha_ai_premium_2year',
						id: 'alpha_ai_premium_2year',
						shopifyId: 'gid://shopify/Product/6777577046119',
						variantId: 'gid://shopify/ProductVariant/41256766079079',
						checked: false,
						sellingPlanId: 'gid://shopify/SellingPlan/9120579687',
					},
				},
				serviceUsCaAuNzPrInProduct: {
					accessories: { label: 'shop.category_filters.categories.services.support.accessories' },
					ackuretta_concierge: {
						label: 'shop.category_filters.categories.services.support.ackuretta_concierge',
						id: 'ackuretta_concierge',
						shopifyId: 'gid://shopify/Product/6779706933351',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					personalized_training_1hr: {
						label: 'shop.category_filters.categories.services.support.personalized_training_1hr',
						id: 'personalized_training_1hr',
						shopifyId: 'gid://shopify/Product/4469342699623',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					personalized_training_3hr: {
						label: 'shop.category_filters.categories.services.support.personalized_training_3hr',
						id: 'personalized_training_3hr',
						shopifyId: 'gid://shopify/Product/4467244335207',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				serviceLatamProduct: {
					// Concierge Service(6779701428327)
					accessories: { label: 'shop.category_filters.categories.services.support.accessories' },
					ackuretta_concierge: {
						label: 'shop.category_filters.categories.services.support.ackuretta_concierge',
						id: 'ackuretta_concierge',
						shopifyId: 'gid://shopify/Product/6779706933351',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					personalized_training_1hr: {
						label: 'shop.category_filters.categories.services.support.personalized_training_1hr',
						id: 'personalized_training_1hr',
						shopifyId: 'gid://shopify/Product/4469342699623',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					personalized_training_3hr: {
						label: 'shop.category_filters.categories.services.support.personalized_training_3hr',
						id: 'personalized_training_3hr',
						shopifyId: 'gid://shopify/Product/4467244335207',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				serviceEuropeProduct: {
					// Concierge Service(6779701428327) and Concierge World(6779706933351)
					accessories: { label: 'shop.category_filters.categories.services.support.accessories' },
					ackuretta_concierge: {
						label: 'shop.category_filters.categories.services.support.ackuretta_concierge',
						id: 'ackuretta_concierge',
						shopifyId: 'gid://shopify/Product/6779706933351',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					personalized_training_1hr: {
						label: 'shop.category_filters.categories.services.support.personalized_training_1hr',
						id: 'personalized_training_1hr',
						shopifyId: 'gid://shopify/Product/4469342699623',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					personalized_training_3hr: {
						label: 'shop.category_filters.categories.services.support.personalized_training_3hr',
						id: 'personalized_training_3hr',
						shopifyId: 'gid://shopify/Product/4467244335207',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				serviceProduct: {
					// Concierge World
					accessories: { label: 'shop.category_filters.categories.services.support.accessories' },
					ackuretta_concierge: {
						label: 'shop.category_filters.categories.services.support.ackuretta_concierge',
						id: 'ackuretta_concierge',
						shopifyId: 'gid://shopify/Product/6779706933351',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					personalized_training_1hr: {
						label: 'shop.category_filters.categories.services.support.personalized_training_1hr',
						id: 'personalized_training_1hr',
						shopifyId: 'gid://shopify/Product/4469342699623',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					personalized_training_3hr: {
						label: 'shop.category_filters.categories.services.support.personalized_training_3hr',
						id: 'personalized_training_3hr',
						shopifyId: 'gid://shopify/Product/4467244335207',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				resinsProduct: {
					accessories: { label: 'shop.category_filters.categories.resins.resins.accessories' },
					ortho_model: {
						label: 'shop.category_filters.categories.resins.resins.ortho_model',
						id: 'ortho_model',
						shopifyId: 'gid://shopify/Product/6893565673575',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					element_model_beige: {
						label: 'shop.category_filters.categories.resins.resins.element_model_beige',
						id: 'element_model_beige',
						shopifyId: 'gid://shopify/Product/6627069591655',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					element_model_white: {
						label: 'shop.category_filters.categories.resins.resins.element_model_white',
						id: 'element_model_white',
						shopifyId: 'gid://shopify/Product/6627069591655',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					// model_yellow: {
					//	label: 'shop.category_filters.categories.resins.resins.model_yellow',
					//	id: 'model_yellow',
					//	shopifyId: 'gid://shopify/Product/6624780812391',
					//	variantId: '',
					//	checked: false,
					//	sellingPlanId: '',
					// },
					prosplint: {
						label: 'shop.category_filters.categories.resins.resins.prosplint',
						id: 'prosplint',
						shopifyId: 'gid://shopify/Product/6627062448231',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					crown: {
						label: 'shop.category_filters.categories.resins.resins.crown',
						id: 'crown',
						shopifyId: 'gid://shopify/Product/6627055435879',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					prodenture: {
						label: 'shop.category_filters.categories.resins.resins.prodenture',
						id: 'prodenture',
						shopifyId: 'gid://shopify/Product/6624785760359',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					ibt: {
						label: 'shop.category_filters.categories.resins.resins.ibt',
						id: 'ibt',
						shopifyId: 'gid://shopify/Product/6600052015207',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					surgical_guide: {
						label: 'shop.category_filters.categories.resins.resins.surgical_guide',
						id: 'surgical_guide',
						shopifyId: 'gid://shopify/Product/6624785924199',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					tray: {
						label: 'shop.category_filters.categories.resins.resins.tray',
						id: 'tray',
						shopifyId: 'gid://shopify/Product/6627069427815',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					progingiva: {
						label: 'shop.category_filters.categories.resins.resins.progingiva',
						id: 'progingiva',
						shopifyId: 'gid://shopify/Product/7186312757351',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					procast: {
						label: 'shop.category_filters.categories.resins.resins.procast',
						id: 'procast',
						shopifyId: 'gid://shopify/Product/6626529214567',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				flowResinsProduct: {
					accessories: { label: 'shop.category_filters.categories.resins.flow_resins.accessories' },
					cnb: {
						label: 'shop.category_filters.categories.resins.flow_resins.cnb',
						id: 'cnb',
						shopifyId: 'gid://shopify/Product/6981479923815',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					denture: {
						label: 'shop.category_filters.categories.resins.flow_resins.denture',
						id: 'denture',
						shopifyId: 'gid://shopify/Product/6981232066663',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					hard_splint: {
						label: 'shop.category_filters.categories.resins.flow_resins.hard_splint',
						id: 'hard_splint',
						shopifyId: 'gid://shopify/Product/6981231870055',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				pacDentProduct: {
					accessories: { label: 'shop.category_filters.categories.resins.pac_dent.accessories' },
					resin_cleaner: {
						label: 'shop.category_filters.categories.resins.pac_dent.resin_cleaner',
						id: 'resin_cleaner',
						shopifyId: 'gid://shopify/Product/7412868808807',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					titan: {
						label: 'shop.category_filters.categories.resins.pac_dent.titan',
						id: 'titan',
						shopifyId: 'gid://shopify/Product/6908629811303',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					sculpture_2: {
						label: 'shop.category_filters.categories.resins.pac_dent.sculpture_2',
						id: 'sculpture_2',
						shopifyId: 'gid://shopify/Product/6908625911911',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					denture_base_2: {
						label: 'shop.category_filters.categories.resins.pac_dent.denture_base_2',
						id: 'denture_base_2',
						shopifyId: 'gid://shopify/Product/6908632727655',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					n2_free_glaze: {
						label: 'shop.category_filters.categories.resins.pac_dent.n2_free_glaze',
						id: 'n2_free_glaze',
						shopifyId: 'gid://shopify/Product/7211636359271',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					n2_free_palette: {
						label: 'shop.category_filters.categories.resins.pac_dent.n2_free_palette',
						id: 'n2_free_palette',
						shopifyId: 'gid://shopify/Product/7211598381159',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					// naturalizing_kit: {label:'shop.category_filters.categories.resins.pac_dent.naturalizing_kit', id: 'naturalizing_kit', shopifyId: 'gid://shopify/Product/6908051226727', variantId: '', checked: false , sellingPlanId: ''},
					// glaze: {label:'shop.category_filters.categories.resins.pac_dent.glaze', id: 'glaze', shopifyId: 'gid://shopify/Product/6909081944167', variantId: '', checked: false , sellingPlanId: ''},
					bond_kit: {
						label: 'shop.category_filters.categories.resins.pac_dent.bond_kit',
						id: 'bond_kit',
						shopifyId: 'gid://shopify/Product/6908636790887',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					rapid_ceram: {
						label: 'shop.category_filters.categories.resins.pac_dent.rapid_ceram',
						id: 'rapid_ceram',
						shopifyId: 'gid://shopify/Product/7345430462567',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					en_vision: {
						label: 'shop.category_filters.categories.resins.pac_dent.en_vision',
						id: 'en_vision',
						shopifyId: 'gid://shopify/Product/7345446813799',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					soft_reline: {
						label: 'shop.category_filters.categories.resins.pac_dent.soft_reline',
						id: 'soft_reline',
						shopifyId: 'gid://shopify/Product/7346306777191',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					try_in: {
						label: 'shop.category_filters.categories.resins.pac_dent.try_in',
						id: 'try_in',
						shopifyId: 'gid://shopify/Product/7346083889255',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					luting_cement: {
						label: 'shop.category_filters.categories.resins.pac_dent.luting_cement',
						id: 'luting_cement',
						shopifyId: 'gid://shopify/Product/7346161123431',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				// categorized by device instead of by item
				// buildplatformProduct: {
				// 	// build_platform:{label: 'shop.category_filters.categories.accessories.build_platform.build_platform', id: 'build_platform', shopifyId: 'gid://shopify/Product/', variantId: '', checked: false , sellingPlanId: ''},
				// 	accessories: {
				// 		label: 'shop.category_filters.categories.accessories.build_platform.build_platform',
				// 	},
				// 	sol_large_bp: {
				// 		label: 'shop.category_filters.categories.accessories.build_platform.sol_large_bp',
				// 		id: 'sol_large_bp',
				// 		shopifyId: 'gid://shopify/Product/6590433951847',
				// 		variantId: '',
				// 		checked: false,
				// 		sellingPlanId: '',
				// 	},
				// 	sol_medium_bp: {
				// 		label: 'shop.category_filters.categories.accessories.build_platform.sol_medium_bp',
				// 		id: 'sol_medium_bp',
				// 		shopifyId: 'gid://shopify/Product/6630922485863',
				// 		variantId: '',
				// 		checked: false,
				// 		sellingPlanId: '',
				// 	},
				// 	sol_small_bp: {
				// 		label: 'shop.category_filters.categories.accessories.build_platform.sol_small_bp',
				// 		id: 'sol_small_bp',
				// 		shopifyId: 'gid://shopify/Product/6630921502823',
				// 		variantId: '',
				// 		checked: false,
				// 		sellingPlanId: '',
				// 	},
				// 	sol_plus_xl_bp: {
				// 		label: 'shop.category_filters.categories.accessories.build_platform.sol_plus_xl_bp',
				// 		id: 'sol_plus_xl_bp',
				// 		shopifyId: 'gid://shopify/Product/6888831844455',
				// 		variantId: '',
				// 		checked: false,
				// 		sellingPlanId: '',
				// 	},
				// 	dentiq_build_platform: {
				// 		label:
				// 			'shop.category_filters.categories.accessories.build_platform.dentiq_build_platform',
				// 		id: 'dentiq_build_platform',
				// 		shopifyId: 'gid://shopify/Product/6590433132647',
				// 		variantId: '',
				// 		checked: false,
				// 		sellingPlanId: '',
				// 	},
				// },
				// categorized by device instead of by item
				// vatProduct: {
				// 	// vat:{label: 'shop.category_filters.categories.accessories.vat.vat', id: 'vat', shopifyId: 'gid://shopify/Product/', variantId: '', checked: false , sellingPlanId: ''},
				// 	accessories: { label: 'shop.category_filters.categories.accessories.vat.vat' },
				// 	sol_vat_assembly: {
				// 		label: 'shop.category_filters.categories.accessories.vat.sol_vat_assembly',
				// 		id: 'sol_vat_assembly',
				// 		shopifyId: 'gid://shopify/Product/6590433722471',
				// 		variantId: '',
				// 		checked: false,
				// 		sellingPlanId: '',
				// 	},
				// 	sol_vat_box: {
				// 		label: 'shop.category_filters.categories.accessories.vat.sol_vat_box',
				// 		id: 'sol_vat_box',
				// 		shopifyId: 'gid://shopify/Product/6776822038631',
				// 		variantId: '',
				// 		checked: false,
				// 		sellingPlanId: '',
				// 	},
				// 	sol_plus_vat_assembly: {
				// 		label: 'shop.category_filters.categories.accessories.vat.sol_plus_vat_assembly',
				// 		id: 'sol_plus_vat_assembly',
				// 		shopifyId: 'gid://shopify/Product/6888878833767',
				// 		variantId: '',
				// 		checked: false,
				// 		sellingPlanId: '',
				// 	},
				// 	sol_plus_vat_box: {
				// 		label: 'shop.category_filters.categories.accessories.vat.sol_plus_vat_box',
				// 		id: 'sol_plus_vat_box',
				// 		shopifyId: 'gid://shopify/Product/6888888729703',
				// 		variantId: '',
				// 		checked: false,
				// 		sellingPlanId: '',
				// 	},
				// 	dentiq_vat: {
				// 		label: 'shop.category_filters.categories.accessories.vat.dentiq_vat',
				// 		id: 'dentiq_vat',
				// 		shopifyId: 'gid://shopify/Product/6590432247911',
				// 		variantId: '',
				// 		checked: false,
				// 		sellingPlanId: '',
				// 	},
				// },
				// categorized by device instead of by item
				// printscreenProduct: {
				// 	// print_screen:{label: 'shop.category_filters.categories.accessories.print_screen.print_screen', id: 'print_screen', shopifyId: 'gid://shopify/Product/', variantId: '', checked: false , sellingPlanId: ''},
				// 	accessories: {
				// 		label: 'shop.category_filters.categories.accessories.print_screen.print_screen',
				// 	},
				// 	sol_print_screen: {
				// 		label: 'shop.category_filters.categories.accessories.print_screen.sol_print_screen',
				// 		id: 'sol_print_screen',
				// 		shopifyId: 'gid://shopify/Product/6590434672743',
				// 		variantId: '',
				// 		checked: false,
				// 		sellingPlanId: '',
				// 	},
				// 	sol_plus_print_screen: {
				// 		label:
				// 			'shop.category_filters.categories.accessories.print_screen.sol_plus_print_screen',
				// 		id: 'sol_plus_print_screen',
				// 		shopifyId: 'gid://shopify/Product/6888890630247',
				// 		variantId: '',
				// 		checked: false,
				// 		sellingPlanId: '',
				// 	},
				// 	dentiq_freeshape_print_screen: {
				// 		label:
				// 			'shop.category_filters.categories.accessories.print_screen.dentiq_freeshape_print_screen',
				// 		id: 'dentiq_freeshape_print_screen',
				// 		shopifyId: 'gid://shopify/Product/6569639837799',
				// 		variantId: '',
				// 		checked: false,
				// 		sellingPlanId: '',
				// 	},
				// },
				// categorized by device instead of by item
				// otherAccessoriesProduct: {
				// 	// other_accesories:{label: 'shop.category_filters.categories.accessories.other_accessories.other_accesories', id: 'other_accesories', shopifyId: 'gid://shopify/Product/', variantId: '', checked: false , sellingPlanId: ''},
				// 	accessories: {
				// 		label:
				// 			'shop.category_filters.categories.accessories.other_accessories.other_accesories',
				// 	},
				// 	sol_plus_heating_rod: {
				// 		label: 'shop.category_filters.categories.accessories.other_accessories.heating_rod',
				// 		id: 'heating_rod',
				// 		shopifyId: 'gid://shopify/Product/6888892006503',
				// 		variantId: '',
				// 		checked: false,
				// 		sellingPlanId: '',
				// 	},
				// 	starter_tool_kit: {
				// 		label:
				// 			'shop.category_filters.categories.accessories.other_accessories.starter_tool_kit',
				// 		id: 'starter_tool_kit',
				// 		shopifyId: 'gid://shopify/Product/6841026019431',
				// 		variantId: '',
				// 		checked: false,
				// 		sellingPlanId: '',
				// 	},
				// 	n2_cover_kit: {
				// 		label: 'shop.category_filters.categories.accessories.other_accessories.n2_cover_kit',
				// 		id: 'n2_cover_kit',
				// 		shopifyId: 'gid://shopify/Product/6841034113127',
				// 		variantId: '',
				// 		checked: false,
				// 		sellingPlanId: '',
				// 	},
				// 	cleani_dual_tank_kit: {
				// 		label:
				// 			'shop.category_filters.categories.accessories.other_accessories.cleani_dual_tank_kit',
				// 		id: 'cleani_dual_tank_kit',
				// 		shopifyId: 'gid://shopify/Product/6897863721063',
				// 		variantId: '',
				// 		checked: false,
				// 		sellingPlanId: '',
				// 	},
				// 	cleani_tank_plus_kit: {
				// 		label:
				// 			'shop.category_filters.categories.accessories.other_accessories.cleani_tank_plus_kit',
				// 		shopifyId: 'gid://shopify/Product/6897863852135',
				// 		variantId: '',
				// 		checked: false,
				// 		sellingPlanId: '',
				// 	},
				// 	hydrometer: {
				// 		label: 'shop.category_filters.categories.accessories.other_accessories.hydrometer',
				// 		shopifyId: 'gid://shopify/Product/6915766321255',
				// 		variantId: '',
				// 		checked: false,
				// 		sellingPlanId: '',
				// 	},
				// },
				solAccessoriesProduct: {
					accessories: { label: 'shop.category_filters.categories.3d_printers.sol.sol' },
					sol_large_bp: {
						label: 'shop.category_filters.categories.3d_printers.sol.large_bp',
						id: 'sol_large_bp',
						shopifyId: 'gid://shopify/Product/6590433951847',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					sol_medium_bp: {
						label: 'shop.category_filters.categories.3d_printers.sol.medium_bp',
						id: 'sol_medium_bp',
						shopifyId: 'gid://shopify/Product/6630922485863',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					sol_small_bp: {
						label: 'shop.category_filters.categories.3d_printers.sol.small_bp',
						id: 'sol_small_bp',
						shopifyId: 'gid://shopify/Product/6630921502823',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					sol_vat_assembly_with_vat_box: {
						label: 'shop.category_filters.categories.3d_printers.sol.sol_vat_assembly',
						id: 'sol_vat_assembly',
						shopifyId: 'gid://shopify/Product/6590433722471',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					sol_vat_box: {
						label: 'shop.category_filters.categories.3d_printers.sol.sol_vat_box',
						id: 'sol_vat_box',
						shopifyId: 'gid://shopify/Product/6776822038631',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					starter_tool_kit: {
						label: 'shop.category_filters.categories.3d_printers.sol.starter_tool_kit',
						id: 'starter_tool_kit',
						shopifyId: 'gid://shopify/Product/6841026019431',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					power_cable: {
						label: 'shop.category_filters.categories.3d_printers.sol.power_cable',
						id: 'power_cable',
						shopifyId: 'gid://shopify/Product/6606441087079',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					wifi_dongle: {
						label: 'shop.category_filters.categories.3d_printers.sol.wifi_dongle',
						id: 'wifi_dongle',
						shopifyId: 'gid://shopify/Product/6606440988775',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				solPlusAccessoriesProduct: {
					accessories: { label: 'shop.category_filters.categories.3d_printers.sol_plus.sol_plus' },
					sol_plus_xl_bp: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.xl_bp',
						id: 'xl_bp',
						shopifyId: 'gid://shopify/Product/6888831844455',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					sol_plus_vat_assembly: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.sol_plus_vat_assembly',
						id: 'sol_plus_vat_assembly',
						shopifyId: 'gid://shopify/Product/6888878833767',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					vat_boxes: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.vat_boxes',
						id: 'vat_boxes',
						shopifyId: 'gid://shopify/Product/6888888729703',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					heating_rod: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.heating_rod',
						id: 'heating_rod',
						shopifyId: 'gid://shopify/Product/6888892006503',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					// starter_tool_kit: {label:'shop.category_filters.categories.3d_printers.sol_plus.starter_tool_kit', id: 'starter_tool_kit', shopifyId: 'gid://shopify/Product/7096899862631', variantId: '', checked: false , sellingPlanId: ''},
					power_cable: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.power_cable',
						id: 'power_cable',
						shopifyId: 'gid://shopify/Product/6606441087079',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					wifi_dongle: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.wifi_dongle',
						id: 'wifi_dongle',
						shopifyId: 'gid://shopify/Product/6606440988775',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				solPlusUsCaAccessoriesProduct: {
					accessories: { label: 'shop.category_filters.categories.3d_printers.sol_plus.sol_plus' },
					sol_plus_xl_bp: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.xl_bp',
						id: 'xl_bp',
						shopifyId: 'gid://shopify/Product/6888831844455',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					sol_plus_vat_assembly: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.sol_plus_vat_assembly',
						id: 'sol_plus_vat_assembly',
						shopifyId: 'gid://shopify/Product/6888878833767',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					vat_boxes: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.vat_boxes',
						id: 'vat_boxes',
						shopifyId: 'gid://shopify/Product/6888888729703',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					heating_rod: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.heating_rod',
						id: 'heating_rod',
						shopifyId: 'gid://shopify/Product/6888892006503',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					// starter_tool_kit: {label:'shop.category_filters.categories.3d_printers.sol_plus.starter_tool_kit', id: 'starter_tool_kit', shopifyId: 'gid://shopify/Product/7096899862631', variantId: '', checked: false , sellingPlanId: ''},
					power_cable: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.power_cable',
						id: 'power_cable',
						shopifyId: 'gid://shopify/Product/6606441087079',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					wifi_dongle: {
						label: 'shop.category_filters.categories.3d_printers.sol_plus.wifi_dongle',
						id: 'wifi_dongle',
						shopifyId: 'gid://shopify/Product/6606440988775',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				curiePlusAccessoriesProduct: {
					accessories: {
						label: 'shop.category_filters.categories.post_processing.curie_plus.curie_plus',
					},
					n2_cover: {
						label: 'shop.category_filters.categories.post_processing.curie_plus.n2_cover_kit',
						id: 'n2_cover_kit',
						shopifyId: 'gid://shopify/Product/6841034113127',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					glass: {
						label: 'shop.category_filters.categories.post_processing.curie_plus.glass',
						id: 'glass',
						shopifyId: 'gid://shopify/Product/7112867905639',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					power_cable: {
						label: 'shop.category_filters.categories.post_processing.curie_plus.power_cable',
						id: 'power_cable',
						shopifyId: 'gid://shopify/Product/6606441087079',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					wifi_dongle: {
						label: 'shop.category_filters.categories.post_processing.curie_plus.wifi_dongle',
						id: 'wifi_dongle',
						shopifyId: 'gid://shopify/Product/6606440988775',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				curieAccessoriesProduct: {
					accessories: { label: 'shop.category_filters.categories.post_processing.curie.curie' },
					glass: {
						label: 'shop.category_filters.categories.post_processing.curie.glass',
						id: 'glass',
						shopifyId: 'gid://shopify/Product/6643132399719',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					power_cable: {
						label: 'shop.category_filters.categories.post_processing.curie.power_cable',
						id: 'power_cable',
						shopifyId: 'gid://shopify/Product/6606441087079',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				cleaniAccessoriesProduct: {
					accessories: {
						label:
							'shop.category_filters.categories.post_processing.cleani_dual_tank.cleani_dual_tank',
					},
					cleani_plus_tank_kit: {
						label:
							'shop.category_filters.categories.post_processing.cleani_dual_tank.cleani_plus_tank_kit',
						shopifyId: 'gid://shopify/Product/6897863852135',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					cleani_dual_tank_kit: {
						label:
							'shop.category_filters.categories.post_processing.cleani_dual_tank.cleani_dual_tank_kit',
						shopifyId: 'gid://shopify/Product/6897863721063',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					hydrometer: {
						label: 'shop.category_filters.categories.post_processing.cleani_dual_tank.hydrometer',
						shopifyId: 'gid://shopify/Product/6915766321255',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					power_cable_ac_adapter: {
						label:
							'shop.category_filters.categories.post_processing.cleani_dual_tank.power_cable_ac_adapter',
						shopifyId: 'gid://shopify/Product/6643132235879',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				solSparePartsProduct: {
					accessories: { label: 'shop.category_filters.categories.spare_parts.sol.sol' },
					print_screen: {
						label: 'shop.category_filters.categories.spare_parts.sol.print_screen',
						id: 'print_screen',
						shopifyId: 'gid://shopify/Product/6590434672743',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					print_screen_frame: {
						label: 'shop.category_filters.categories.spare_parts.sol.print_screen_frame',
						id: 'print_screen_frame',
						shopifyId: 'gid://shopify/Product/6615369089127',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					print_screen_module: {
						label: 'shop.category_filters.categories.spare_parts.sol.print_screen_module',
						id: 'print_screen_module',
						shopifyId: 'gid://shopify/Product/6606440956007',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					glass: {
						label: 'shop.category_filters.categories.spare_parts.sol.glass',
						id: 'glass',
						shopifyId: 'gid://shopify/Product/6606440890471',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					carton_box_with_insert: {
						label: 'shop.category_filters.categories.spare_parts.sol.carton_box_with_insert',
						id: 'carton_box_with_insert',
						shopifyId: 'gid://shopify/Product/7096853332071',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				solPlusSparePartsProduct: {
					accessories: { label: 'shop.category_filters.categories.spare_parts.sol_plus.sol_plus' },
					print_screen: {
						label: 'shop.category_filters.categories.spare_parts.sol_plus.print_screen',
						id: 'print_screen',
						shopifyId: 'gid://shopify/Product/6888890630247',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					print_screen_frame: {
						label: 'shop.category_filters.categories.spare_parts.sol_plus.print_screen_frame',
						id: 'print_screen_frame',
						shopifyId: 'gid://shopify/Product/7096938692711',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					heating_rod_board: {
						label: 'shop.category_filters.categories.spare_parts.sol_plus.heating_rod_board',
						id: 'heating_rod_board',
						shopifyId: 'gid://shopify/Product/7103385337959',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					glass: {
						label: 'shop.category_filters.categories.spare_parts.sol_plus.glass',
						id: 'glass',
						shopifyId: 'gid://shopify/Product/7096942231655',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					carton_box_with_insert: {
						label: 'shop.category_filters.categories.spare_parts.sol.carton_box_with_insert',
						id: 'carton_box_with_insert',
						shopifyId: 'gid://shopify/Product/7096949407847',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				cleaniSparePartsProduct: {
					accessories: { label: 'shop.category_filters.categories.spare_parts.cleani.cleani' },
					base: {
						label: 'shop.category_filters.categories.spare_parts.cleani.base',
						id: 'base',
						shopifyId: 'gid://shopify/Product/7097038536807',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
					packaging_box: {
						label: 'shop.category_filters.categories.spare_parts.cleani.packaging_box',
						id: 'packagin_box',
						shopifyId: 'gid://shopify/Product/7097039192167',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				curiePlusSparePartsProduct: {
					accessories: {
						label: 'shop.category_filters.categories.spare_parts.curie_plus.curie_plus',
					},
					packaging_box_with_insert: {
						label:
							'shop.category_filters.categories.spare_parts.curie_plus.packaging_box_with_insert',
						id: 'packaging_box_with_insert',
						shopifyId: 'gid://shopify/Product/7097040109671',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
				curieSparePartsProduct: {
					accessories: { label: 'shop.category_filters.categories.spare_parts.curie.curie' },
					packaging_box_with_insert: {
						label: 'shop.category_filters.categories.spare_parts.curie.packaging_box_with_insert',
						id: 'packaging_box_with_insert',
						shopifyId: 'gid://shopify/Product/7097039585383',
						variantId: '',
						checked: false,
						sellingPlanId: '',
					},
				},
			},
		};
	},
	methods: {
		...Vuex.mapActions(['setPageIsLoading']),
		...Vuex.mapActions('shop', [
			'getProducts',
			'addToCart',
			'setProductsDefaultView',
			'checkoutCart',
			'setSortCriteria',
			'setCurrentPage',
			'unselectAllProducts',
			'clearAllFilters',
			'setBundleView',
			'addAccordion',
		]),
		initPageView() {
			let urlParams = new URLSearchParams(window.location.search);
			const setPageViewHandlers = {
				default: async () => {
					await this.setProductsDefaultView();
					this.addAccordion('heading3DPrinter');
					EventBus.$emit('showListedAccordions');
				},
				collection: async (collection) => {
					await this.setProductsDefaultView({ tag: collection, reverse: true });
					EventBus.$emit('activeCollectionFilter');
					setTimeout(() => {
						this.onSelectAllClick();
					}, 300);
				},
				bundle: async (bundle) => {
					await this.setBundleView({ tag: bundle, reverse: true });
					EventBus.$emit('activeCollectionFilter');
					setTimeout(() => {
						this.onSelectAllClick();
					}, 300);
				},
			};
			const paramType = Object.keys(setPageViewHandlers).find((paramType) =>
				urlParams.has(paramType),
			);

			paramType
				? setPageViewHandlers[paramType](urlParams.get(paramType))
				: setPageViewHandlers['default']();
		},
		goToPage(pageNumber) {
			this.setCurrentPage(pageNumber);
		},
		showOffcanvasMenu() {
			this.mobileMenuOpened = !this.mobileMenuOpened;
		},

		onAddToCartClick() {
			this.addToCart(this.selectedProductList);
			this.unselectAllProducts();
		},

		onUnSelectAllClick() {
			this.unselectAllProducts();
		},

		onSelectAllClick() {
			EventBus.$emit('select-all-products');
		},

		onClearAllFiltersClick() {
			EventBus.$emit('shop-unselect-all-filters');
			this.clearAllFilters();
		},

		onCheckAllFiltersClick() {
			EventBus.$emit('shop-select-all-filters');
		},

		/*
    loadBundle(bundleTag){
      this.setBundleView({tag: bundleTag, reverse: true})
        .then(() => {
          this.onSelectAllClick()
        })
    }
    */

		loadBundle(bundleTag) {
			const { tag, title, description } = bundleTag;
			this.selectedBundle = tag;
			this.bundleTitle = title;
			this.bundleDescription = description;
			this.setBundleView({ tag, reverse: true }).then(() => {
				EventBus.$emit('reset-accordionsAll');
				EventBus.$emit('activeCollectionFilter');
				setTimeout(() => {
					this.onSelectAllClick();
				}, 300);
			});
		},
	},
	watch: {
		productSortSelect: {
			handler() {
				this.setSortCriteria(this.productSortSelect);
			},
			deep: false,
		},
	},
});
